export const ru = {
    'search-input-text': 'Найти',
    'video-stock-search-input-text': 'Поиск видео'
};
